"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = exports.ETI_TYPE = void 0;
const lodash_functions_1 = require("../../../../util/lodash-functions");
const default_session_1 = require("../../../../session/default-session");
const surfaces_provider_1 = require("../surfaces-provider");
exports.ETI_TYPE = 'Eti';
function Definition(params, surfaceTag) {
    let parameters;
    if ((0, lodash_functions_1.isPlainObject)(params)) {
        parameters = params;
    }
    else {
        parameters = {
            surfaceTag,
            instrumentCode: params,
        };
    }
    const { outputs, extendedParams, instrumentCode, cleanInstrumentCode, exchange, isFutureUnderlying } = parameters, instrumentDefinition = __rest(parameters, ["outputs", "extendedParams", "instrumentCode", "cleanInstrumentCode", "exchange", "isFutureUnderlying"]);
    const requestItem = Object.assign(Object.assign({}, instrumentDefinition), { underlyingDefinition: {
            instrumentCode,
            cleanInstrumentCode,
            exchange,
            isFutureUnderlying,
        }, underlyingType: exports.ETI_TYPE });
    return {
        getData(session = (0, default_session_1.getDefault)()) {
            const financialContracts = new surfaces_provider_1.SurfacesProvider(session);
            return financialContracts.getSurfaces([requestItem], { extendedParams, outputs });
        },
        /** @internal */
        getInstrument() {
            return requestItem;
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2lwYS9zdXJmYWNlcy9ldGkvZGVmaW5pdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7OztBQUVBLHdFQUFrRTtBQUNsRSx5RUFBaUU7QUFDakUsNERBQXdEO0FBRTNDLFFBQUEsUUFBUSxHQUFHLEtBQUssQ0FBQztBQUk5QixTQUFnQixVQUFVLENBQ3RCLE1BQXdDLEVBQ3hDLFVBQW1CO0lBRW5CLElBQUksVUFBbUMsQ0FBQztJQUV4QyxJQUFJLElBQUEsZ0NBQWEsRUFBQyxNQUFNLENBQUMsRUFBRSxDQUFDO1FBQ3hCLFVBQVUsR0FBRyxNQUFpQyxDQUFDO0lBQ25ELENBQUM7U0FBTSxDQUFDO1FBQ0osVUFBVSxHQUFHO1lBQ1QsVUFBVTtZQUNWLGNBQWMsRUFBRSxNQUFnQjtTQUNuQyxDQUFDO0lBQ04sQ0FBQztJQUNELE1BQU0sRUFBRSxPQUFPLEVBQUUsY0FBYyxFQUFFLGNBQWMsRUFBRSxtQkFBbUIsRUFBRSxRQUFRLEVBQUUsa0JBQWtCLEtBQzlGLFVBQVUsRUFEeUYsb0JBQW9CLFVBQ3ZILFVBQVUsRUFEUix3R0FBdUgsQ0FDL0csQ0FBQztJQUNmLE1BQU0sV0FBVyxtQ0FDVixvQkFBb0IsS0FDdkIsb0JBQW9CLEVBQUU7WUFDbEIsY0FBYztZQUNkLG1CQUFtQjtZQUNuQixRQUFRO1lBQ1Isa0JBQWtCO1NBQ3JCLEVBQ0QsY0FBYyxFQUFFLGdCQUFRLEdBQzNCLENBQUM7SUFFRixPQUFPO1FBQ0gsT0FBTyxDQUFDLFVBQW1CLElBQUEsNEJBQVUsR0FBRTtZQUNuQyxNQUFNLGtCQUFrQixHQUFHLElBQUksb0NBQWdCLENBQUMsT0FBTyxDQUFDLENBQUM7WUFFekQsT0FBTyxrQkFBa0IsQ0FBQyxXQUFXLENBQUMsQ0FBQyxXQUFXLENBQUMsRUFBRSxFQUFFLGNBQWMsRUFBRSxPQUFPLEVBQUUsQ0FBQyxDQUFDO1FBQ3RGLENBQUM7UUFDRCxnQkFBZ0I7UUFDaEIsYUFBYTtZQUNULE9BQU8sV0FBVyxDQUFDO1FBQ3ZCLENBQUM7S0FDSixDQUFDO0FBQ04sQ0FBQztBQXRDRCxnQ0FzQ0MifQ==